var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2TipSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 254,
    viewBox: "0 0 25 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5822 192.737H9.49289C9.22503 192.737 9.01074 192.483 9.01074 192.165L9.01074 184.737H15.0107V192.165C15.0107 192.483 14.7965 192.737 14.5822 192.737Z",
    fill: "#99B2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01074 122.737H12.0107V167.737H8.01074C8.01074 167.737 7.43931 138.937 4.01074 122.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0107 122.737H12.0107V167.737H16.0107C16.0107 167.737 16.5822 138.937 20.0107 122.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01074 127.737C8.01074 125.528 9.8016 123.737 12.0107 123.737V123.737C14.2199 123.737 16.0107 125.528 16.0107 127.737V186.737C16.0107 187.841 15.1153 188.737 14.0107 188.737H10.0107C8.90617 188.737 8.01074 187.841 8.01074 186.737V127.737Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0107 106.737H2.01074L2.01074 122.737C2.01074 123.841 6.48789 124.737 12.0107 124.737C17.5336 124.737 22.0107 123.841 22.0107 122.737L22.0107 106.737Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0076 109.69L24.0076 27.7367C24.0076 26.3293 23.2534 25.6435 22.0193 25.0403L17.6313 22.8957L12.0777 20.2819L5.90711 23.2308L2.06761 25.0403C0.764929 25.6435 0.0107422 26.8499 0.0107422 28.2573L0.0107422 109.737C0.0107422 110.841 5.38332 111.737 12.0107 111.737C18.6382 111.737 24.0107 110.841 24.0107 109.737C24.0107 109.721 24.0097 109.706 24.0076 109.69Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 25,
    height: 92
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0076 109.69L24.0076 27.7367C24.0076 26.3293 23.2534 25.6435 22.0193 25.0403L17.6313 22.8957L12.0777 20.2819L5.90711 23.2308L2.06761 25.0403C0.764929 25.6435 0.0107422 26.8499 0.0107422 28.2573L0.0107422 109.737C0.0107422 110.841 5.38332 111.737 12.0107 111.737C18.6382 111.737 24.0107 110.841 24.0107 109.737C24.0107 109.721 24.0097 109.706 24.0076 109.69Z",
    fill: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0107422,
    y: 24.7367,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.0107,
    y: 24.7367,
    width: 6,
    height: 87,
    fill: "#E5ECF0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.0773 20.6847C14.6522 20.6847 16.7395 19.8745 16.7395 18.8751C16.7395 17.8757 14.6522 17.0656 12.0773 17.0656C9.5024 17.0656 7.41504 17.8757 7.41504 18.8751C7.41504 19.8745 9.5024 20.6847 12.0773 20.6847Z",
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8525 21.7563C19.4813 19.6117 17.3558 18.0032 14.9561 17.333C14.4762 17.6681 13.3792 17.8692 12.008 17.8692C10.7053 17.8692 9.67684 17.6681 9.12834 17.4C6.72865 18.1373 4.53466 19.6117 3.16341 21.8234C2.68347 22.6276 2.47778 23.6329 2.47778 24.5712L2.47778 33.753C2.47778 34.4902 3.16341 35.0264 3.91759 34.9593C6.18015 34.5572 8.85409 34.2891 11.8023 34.2891C14.9561 34.2891 17.6986 34.5572 20.0983 34.9593C20.8525 35.0934 21.5381 34.5572 21.5381 33.753L21.5381 24.4372C21.5381 23.4989 21.3324 22.5606 20.8525 21.7563Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44214 23.298C4.40201 22.0246 5.77326 21.0863 7.21307 20.3491C7.96726 20.014 8.72144 19.7459 9.54419 19.5448C10.3669 19.3438 11.1897 19.2767 12.0124 19.2767C13.6579 19.2767 15.372 19.6118 16.8118 20.3491C18.3202 21.0193 19.6229 22.0246 20.5827 23.298C19.2115 22.4267 17.8402 21.7565 16.4004 21.2873C15.6462 21.0863 14.9606 20.8852 14.2064 20.7512C13.4523 20.6171 12.6981 20.5501 11.9439 20.5501C10.4355 20.5501 8.92713 20.8182 7.48732 21.2203C6.18464 21.7565 4.74482 22.4267 3.44214 23.298Z",
    fill: "#D67568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0107 55.7367H8.01074L8.01074 83.6482H16.0107L16.0107 55.7367Z",
    fill: "#F79689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 61.3698H9.78027L9.78027 77.5954H14.3386L14.3386 61.3698Z",
    fill: "#FBF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 61.3698H9.78027V61.706H14.3386V61.3698Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 77.3431H9.78027V77.6794H14.3386V77.3431Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 72.0464H9.78027V72.3827H14.3386V72.0464Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 66.666H9.78027V67.0023H14.3386V66.666Z",
    fill: "#A49448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.129 62.975C12.4313 62.975 12.6713 63.0586 12.8491 63.226C13.0284 63.3918 13.118 63.6135 13.118 63.8909C13.118 64.1023 13.0511 64.3312 12.9175 64.5778C12.7853 64.8244 12.5521 65.151 12.2179 65.5576H13.3094V66.0904H11.2471V66.0266C11.4871 65.7403 11.693 65.4835 11.8646 65.256C12.0378 65.027 12.1715 64.8376 12.2657 64.6879C12.3599 64.5367 12.4267 64.4083 12.4662 64.3026C12.5057 64.1969 12.5255 64.0876 12.5255 63.9746C12.5255 63.8336 12.4784 63.7155 12.3842 63.6201C12.2915 63.5232 12.1784 63.4748 12.0447 63.4748C11.8046 63.4748 11.5555 63.6069 11.2972 63.8711V63.2678C11.5691 63.0726 11.8464 62.975 12.129 62.975Z",
    fill: "#101620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2931 68.2435C12.6151 68.2435 12.8704 68.3837 13.0587 68.6641C13.2486 68.9444 13.3436 69.3275 13.3436 69.8134C13.3436 70.3036 13.2502 70.6904 13.0633 70.9737C12.8764 71.257 12.6212 71.3986 12.2976 71.3986C11.9695 71.3986 11.7097 71.2584 11.5183 70.9781C11.3283 70.6962 11.2334 70.3109 11.2334 69.8222C11.2334 69.3348 11.3283 68.9503 11.5183 68.6685C11.7082 68.3852 11.9664 68.2435 12.2931 68.2435ZM11.8259 69.8398C11.8259 70.5429 11.9816 70.8944 12.2931 70.8944C12.5969 70.8944 12.7488 70.5245 12.7488 69.7847C12.7488 69.0934 12.5954 68.7477 12.2885 68.7477C11.9801 68.7477 11.8259 69.1117 11.8259 69.8398Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2989 73.4825C12.621 73.4825 12.8762 73.6227 13.0646 73.9031C13.2545 74.1834 13.3495 74.5665 13.3495 75.0524C13.3495 75.5426 13.256 75.9294 13.0692 76.2127C12.8823 76.496 12.6271 76.6376 12.3035 76.6376C11.9753 76.6376 11.7155 76.4974 11.5241 76.2171C11.3342 75.9353 11.2393 75.55 11.2393 75.0612C11.2393 74.5739 11.3342 74.1893 11.5241 73.9075C11.714 73.6242 11.9723 73.4825 12.2989 73.4825ZM11.8318 75.0788C11.8318 75.7819 11.9875 76.1334 12.2989 76.1334C12.6028 76.1334 12.7547 75.7635 12.7547 75.0237C12.7547 74.3324 12.6012 73.9867 12.2944 73.9867C11.986 73.9867 11.8318 74.3508 11.8318 75.0788Z",
    fill: "#DB0300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4718 24.7722V33.7529C21.4718 34.4901 20.8547 35.0263 20.032 34.8923C19.2778 34.7582 18.455 34.6912 17.5637 34.5572L17.5637 23.1637C18.6607 23.5658 19.2778 23.9009 20.2377 24.303C20.9918 24.5041 20.9918 24.5041 21.4718 24.7722Z",
    fill: "#D67568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54785 24.7743L2.54785 33.755C2.54785 34.4922 3.16491 35.0284 3.98766 34.8943C4.74185 34.7603 5.5646 34.6933 6.45591 34.5592L6.45591 23.1658C5.35891 23.5679 4.74185 23.903 3.78197 24.3051C3.02779 24.5062 3.02779 24.5062 2.54785 24.7743Z",
    fill: "#D67568"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 7.30029,
    y: 187.064,
    width: 10,
    height: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 187,
    width: 10,
    height: 41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80029 187.064H16.8003L16.3003 198.064H15.967L15.8003 203.064H15.2203L13.3003 227.064H11.3003L9.38029 203.064H8.80034L8.63368 198.064H8.30029L7.80029 187.064Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.80029 187.064L16.8003 187.064L16.3003 198.064L8.30029 198.064L7.80029 187.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.60034 197.064L16.0003 197.064L15.8003 203.064L8.80034 203.064L8.60034 197.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M9.30029 202.064L15.3003 202.064L13.3003 227.064L11.3003 227.064L9.30029 202.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M10.3003 202.064L11.6003 227.064L11.3003 227.064L9.40029 203.064L8.80029 203.064L8.60029 198.064L8.30029 198.064L7.80029 188.064L9.30029 187.564L10.3003 202.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M14.3003 202.064L13.0003 227.064L13.3003 227.064L15.2003 203.064L15.8003 203.064L16.0003 198.064L16.3003 198.064L16.8003 188.064L15.3003 187.564L14.3003 202.064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3003 188.064H7.46978L7.30029 189.064H17.2664L17.3003 188.064ZM8.45284 198.064H17.3003L17.2698 199.064H8.30029L8.45284 198.064ZM9.40029 203.064H15.2003L15.1803 204.064H9.30029L9.40029 203.064Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M14.1003 205.064L10.5002 205.064L11.6003 227.064L13.0003 227.064L14.1003 205.064Z",
    fill: "#E00000"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2.98926,
    y: -0.936035,
    width: 30.2949,
    height: 259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 253,
    fill: "white",
    transform: "translate(0.305664 0.0639648)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 64,
    fill: "white",
    transform: "translate(7.30029 187.064)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2TipSolution);
export default __webpack_public_path__ + "static/media/P2-Tip-Solution.096e5554eb68c10927e7476afb485909.svg";
export { ForwardRef as ReactComponent };